<template>
  <div>
    <div class="mb-10">
      <form @submit.prevent>
        <div>
          <span class="text-gray-700 block mb-1">Kies een CSV-bestand met contactgegevens</span>
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="file" ref="file" @change="change" />
            <label class="custom-file-label" for="file">{{ filename || "Selecteer bestand" }}</label>
          </div>
        </div>
        <div class="bg-orange-100 mt-3 px-4 py-3 rounded text-orange-900">
          <p>Importeer een CSV bestand met organisaties. Per organisatie kun je tevens (optioneel) één contactpersoon importeren.</p>
          <p>
            Organisaties die al in het systeem staan worden niet opgeslagen.
            De contactpersoon wordt in dit geval aan het bestaande bedrijf toegevoegd.
          </p>
        </div>
      </form>
    </div>
    <div class="flex justify-end">
      <router-link class="btn btn-blue flex items-center" :to="{ name: 'import.step2' }" replace>
        <span class="mr-1">Volgende stap</span>
        <BaseIcon name="chevron-right" />
      </router-link>
    </div>
  </div>
</template>

<script>
import Papa from "papaparse";
import { determineEncoding } from "@/functions.js";

export default {
  computed: {
    filename() {
      return this.$store.state.import.filename;
    }
  },

  methods: {
    change() {
      let file = this.$refs.file.files[0];

      if (!file) return;

      if (!file.name.includes(".csv")) {
        this.$store.commit("FLASH_ADD", {
          message: "Het is alleen mogelijk CSV-bestanden te importeren",
          type: "warning"
        });
        return;
      }

      // Try to determine the encoding of the file
      let reader = new FileReader();
      reader.onload = () => this.parseFile(file, reader);
      reader.readAsArrayBuffer(file);
    },

    parseFile(file, reader) {
      let encoding = determineEncoding(reader.result) || "ISO-8859-1";

      Papa.parse(file, {
        skipEmptyLines: true,
        encoding,
        complete: (results, file) => {
          this.$store.commit("SET_IMPORT", {
            filename: file.name,
            encoding,
            data: results.data
          });
        }
      });
    }
  }
};
</script>
